module.exports = __webpack_public_path__ + "img/map_Z2.4.C.03.6538e9ac.svg";